import React from 'react';
import PropTypes from 'prop-types';

import Table from '@appComponents/Table';
import {Columns} from '@modules/spiideoMappings/components/Table/Columns';
import {RowRenderer} from '@modules/spiideoMappings/components/Table/RowRenderer';

const SpiideoVenuesTable = ({data, loading}) => (
    <Table
        name='spiideoVenuesTable'
        columns={Columns}
        data={data}
        loading={loading}
        rowRenderer={RowRenderer}
        noDataText='No venue mappings found'
        pagination={true}
        defaultSort='venue'
    />
);

SpiideoVenuesTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            spiideo_scene_uuid: PropTypes.string,
            stadium: PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
                city: PropTypes.shape({
                    id: PropTypes.string,
                    name: PropTypes.string,
                }),
            }),
        })
    ),
    loading: PropTypes.bool,
};

export default SpiideoVenuesTable;
